import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductSectionComponentBase } from '../../../ProductSectionComponentBase';
import { ProductSectionComponent } from '../../product-section';
import { ProductSpecificationsComponent } from '../product-specifications';

@Component({
  selector: 'ideal-product-section-specifications',
  imports: [ProductSectionComponent, ProductSpecificationsComponent],
  templateUrl: './product-section-specifications.component.html',
  styleUrl: './product-section-specifications.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.display]': 'hasContent() ? undefined : "none"',
  },
})
export class ProductSectionSpecificationsComponent extends ProductSectionComponentBase {}
